import { BehaviorSubject } from "rxjs";

import { type APIProjectResponse } from "@/data_source/models/APIProjectResponse";

import { Store } from "./store";

export class ProjectsStore extends Store<Partial<APIProjectResponse>[]> {
  protected _observable: BehaviorSubject<Partial<APIProjectResponse>[] | null>;
  private static instance?: ProjectsStore;
  private constructor() {
    super();
    this._observable = new BehaviorSubject<
      Partial<APIProjectResponse>[] | null
    >([]);
  }
  static getInstance(): ProjectsStore {
    ProjectsStore.instance = ProjectsStore.instance ?? new ProjectsStore();
    return ProjectsStore.instance;
  }
}
